import { createFileRoute } from '@tanstack/react-router';
import { SpacePostDetailPage } from '../../../../../../features/community-hub/components/space-post-detail-page';

/**
 * Community Hub - Space Post Detail Route
 * Path: /community-hub/spaces/:id/posts/:postId
 *
 * Shows a single post within a space context with comments and reactions
 * Breadcrumbs link back to the space's community tab
 */
export const Route = createFileRoute('/_protected/community-hub/spaces/$id/posts/$postId')({
  component: SpacePostDetailPage,
});
